import { defaultFilter } from '@fabric-ui/components/Table';
import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { EntityTypeConfigKeys } from '@utils/entityViewConfig';
import { PAGE_PATHS } from '../../../../../../types';

const path = PAGE_PATHS.ASSETS;
export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/assets/assets/{-$id}/')({
  staticData: {
    path,
    key: EntityTypeConfigKeys.Asset,
  },
  validateSearch: zodValidator(withDefaults(schema.ASSETS, defaultFilter)),
  search: {
    middlewares: [stripSearchParams(defaultFilter)],
  },
});
